import type { LatLngExpression } from "leaflet";
import type { RouteWaypointsResponse } from "~/shared/api/cost-provider/cost-provider.api";
import { decodePolyline } from "./polyline-decoder";

/**
 * Converts route_waypoints API response to Leaflet coordinates
 * Decodes all polyline steps from all legs and combines them into a single path
 */
export function decodeRouteWaypoints(response: RouteWaypointsResponse): LatLngExpression[] {
  const coordinates: LatLngExpression[] = [];

  if (!response.legs) {
    return coordinates;
  }

  response.legs.forEach((leg) => {
    if (!leg.steps) return;

    leg.steps.forEach((step) => {
      if (step.points) {
        // Decode polyline points (v6 format)
        const decoded = decodePolyline(step.points);
        coordinates.push(...decoded);
      }
    });
  });

  return coordinates;
}
